<template>
    <nav class="navbar-custom">
        <div class="nav-inner">
            <div class="nav-brand">
                <span class="brand-icon">
                  <span class="icon-bracket">&lt;</span>
                  <span class="icon-slash">/</span>
                  <span class="icon-bracket">&gt;</span>
                </span>
                <span class="brand-text">DCTECH 编程课堂</span>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
    data() {
        return {};
    },
}
</script>

<style lang="scss" scoped>
.navbar-custom {
    height: 64px;
    background: linear-gradient(135deg, #1e3a5f 0%, #1a2942 50%, #162032 100%);
    box-shadow: 0 2px 8px rgba(0,0,0,0.2);
    position: relative;
    z-index: 100;
    border-bottom: 1px solid rgba(255,255,255,0.08);

    &::after {
      content: '';
      position: absolute;
      bottom: -1px;
      left: 0;
      right: 0;
      height: 2px;
      background: linear-gradient(90deg, transparent, #3b82f6, #60a5fa, transparent);
    }
}

.nav-inner {
    height: 100%;
    padding: 0 24px;
    display: flex;
    align-items: center;
}

.nav-brand {
    display: flex;
    align-items: center;
    gap: 10px;
}

.brand-icon {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: linear-gradient(135deg, #3b82f6, #2563eb);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1px;
    font-size: 16px;
    font-weight: 800;
    color: #fff;
    font-family: 'Fira Code', 'Consolas', monospace;
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.4);
}

.icon-bracket {
    opacity: 0.8;
}

.icon-slash {
    color: #93c5fd;
    font-weight: 700;
}

.brand-text {
    font-size: 18px;
    font-weight: 600;
    color: #f1f5f9;
    letter-spacing: 0.5px;
}
</style>
